import { Box, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";

const NextOfKin = ({ patientData }) => {
  const nokData = [
    { key: "Name", value: patientData?.nextOfKin?.name },
    { key: "Relationship", value: patientData?.nextOfKin?.relationship },
    { key: "Telephone", value: patientData?.nextOfKin?.telephone },
    { key: "Address", value: patientData?.nextOfKin?.address },
  ];

  return (
    <Box w="full">
      <HStack mt="30px" spacing={"10px"}>
        <Box h="35px" w="3px" bg="#354147" />
        <Text
          lineHeight={"24.2px"}
          fontSize={"20px"}
          fontWeight={600}
          color={"#354147"}
        >
          NEXT OF KIN
        </Text>
      </HStack>

      <Flex maxW={"936px"} flexWrap={"wrap"} p="20px" gap="25px">
        {nokData.map((data) => (
          <VStack
            key={data.key}
            w="272px"
            color={"#354147"}
            align={"flex-start"}
            spacing={"3px"}
          >
            <Text
              fontSize={"16px"}
              fontWeight={500}
              lineHeight={"19.36px"}
              opacity={0.5}
            >
              {data.key}
            </Text>
            <Text fontSize={"18px"} fontWeight={500} lineHeight={"31.78px"}>
              {data.value}
            </Text>
          </VStack>
        ))}
      </Flex>
    </Box>
  );
};

export default NextOfKin;
